import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import { Box, Grid } from '@mui/material';

import GenericFormContainer from '../Forms/GenericFormContainer';

import LogoComponent from './LogoComponent';

import { logout } from './actionCreators';

import { isAuthenticated } from '../../utils';
import {
  lengthValidation60,
  required,
  validateEmail,
  validatePassword,
} from '../Forms/utils';

import { STYLED_PASSWORD, STYLED_TEXT } from '../Forms/fieldTypes';
import AppleLogin from './AppleLogin';
import AuthDivider from './AuthDivider';
import FacebookLoginComponent from './FacebookLogin';
import SignInWithGoogle from './SignInWithGoogle';
import { StyledSocialMediaButtonContainer } from './styledComponents';

const validate = (values) => {
  const errors = {};
  if (values.password !== values.confirmPassword) {
    errors.password = 'Password fields must match';
    errors.confirmPassword = 'Password fields must match';
  }
  return errors;
};

const SignupComponent = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { branchValues, onSocialSignup, form, onSubmit, initialValues } = props;

  if (isEmpty(branchValues)) history.replace('./');
  if (isAuthenticated()) logout(dispatch);

  const isValidEmail = !validateEmail(initialValues?.username);

  const formData = [
    {
      keyName: 'username',
      label: 'Username',
      fieldType: STYLED_TEXT,
      validate: [required],
      disabled: isValidEmail,
    },
    {
      keyName: 'password',
      label: 'Password',
      fieldType: STYLED_PASSWORD,
      validate: [required, validatePassword, lengthValidation60],
      showPasswordRequirements: true,
    },
    {
      keyName: 'confirmPassword',
      label: 'Confirm Password',
      fieldType: STYLED_PASSWORD,
      validate: [required, validatePassword, lengthValidation60],
    },
    {
      keyName: 'person',
      label: 'Person',
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: true,
    },
    {
      keyName: 'source',
      label: 'Source',
      fieldType: STYLED_TEXT,
      validate: [],
      isHidden: true,
    },
  ];

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      sx={{ margin: 'auto', height: '100%', width: '34rem', padding: 0 }}
    >
      <LogoComponent />
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={onSubmit}
        initialValues={initialValues}
        title="Sign Up"
        submitText="Sign Up"
        customSubmitStyle={{ borderRadius: '20px' }}
        validate={validate}
        backButton={false}
        canBeUpdated={false}
        isFullWidthSubmit
        isFullWidthForm
        isCentered
      />
      <Box width="100%" mt="-2rem">
        <AuthDivider />
        <StyledSocialMediaButtonContainer>
          <FacebookLoginComponent
            loginWithFacebook={(tokenId) =>
              onSocialSignup('facebook', tokenId, branchValues)
            }
            facebookButtonLabel="Sign up with Facebook"
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <AppleLogin
            signInWithApple={(token) =>
              onSocialSignup('apple-id', token, branchValues)
            }
            appleButtonLabel="Sign up with Apple"
          />
        </StyledSocialMediaButtonContainer>
        <StyledSocialMediaButtonContainer>
          <SignInWithGoogle
            onSignInWithGoogle={({ credential }) =>
              onSocialSignup('google-oauth2', credential, branchValues)
            }
            isLogin={false}
          />
        </StyledSocialMediaButtonContainer>
      </Box>
    </Grid>
  );
};

SignupComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  branchValues: PropTypes.instanceOf(Object).isRequired,
  onSocialSignup: PropTypes.func.isRequired,
};

export default SignupComponent;
